<script>
import BusienssService from "@/services/Business";
import Swal from "sweetalert2";

export default {
  props: {
      modalData: {
          type: Object,
      }
  },
  data() {
      return {
          assetsDefinition: [],
          selectedAssetId:null,
          tryingToEdit: false,
          errorMessage:'',
          loading: false,
      };
  },
  methods: {

    async getBusinessAssets(){
        try {
            this.loading= true
            const response = await BusienssService.getBusinessAssets('active=1')
            this.assetsDefinition = response.data.data
            this.loading= false
        } catch (error) {
            this.assetsDefinition = []
            this.loading= false
        } finally {
            this.toggleBusy();
            this.loading= false
        }
    },

    async saveChanges() {
        this.tryingToEdit = true;
        const payload = {
          company_id:this.modalData.company_id,
          asset_id: this.selectedAssetId,
        };
        try {
            const response = await BusienssService.addBusinessCompanyAssets(payload);
            if (response.status >= 200 && response.status < 300) {
                // Emit event for parent to update after save
                this.$emit('onRefresh');  // Emit refreshTable only after saving
                this.$bvModal.hide('add_business_company_assets');  // Close the modal after save
                Swal.fire("Success!", "Business Assets successfully added!", "success");
            } else {
                Swal.fire("Fail!", "Add Business Assets Failed !", "warning");
            }
        } catch (error) {
            this.tryingToEdit = false;
            let errorMessage = error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "Error Add Business Assets"
            if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
            }
            Swal.fire("Fail!", errorMessage, "warning");
        }
        this.tryingToEdit = false;
    },

    closeModal() {
        // Only hide the modal, no page reload or table refresh here
        this.$bvModal.hide('add_business_company_assets');
        this.assetsDefinition=[],
        this.errorMessage=''
    },

  },
  computed: {

  },


};
</script>

<template>
    <b-modal id="add_business_company_assets" @shown="getBusinessAssets()" title="Add Business Asset To Company" @hidden="closeModal"  size="xl" centered>
      <template v-slot:default v-if="assetsDefinition && !loading">
        <div class="row">
          <div class="col-sm-6">
            <b-form-group label="Select Business Asset">
              <b-form-select
                  v-model="selectedAssetId"
                  :options="assetsDefinition.map(provider => ({ text: provider.name, value: provider.id }))"
                  placeholder="Select Business Asset"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled>Select an Asset</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </div>
        </div>
      </template>
      <div v-if="errorMessage">
          <h3 class="text-center text-danger">{{errorMessage}}</h3>
      </div>
      <template v-slot:modal-footer>
          <b-button variant="light" @click="closeModal">Cancel</b-button>
          <b-button @click="saveChanges" v-if="assetsDefinition" variant="primary"  :disabled="tryingToEdit">Submit
              <b-spinner v-show="tryingToEdit" small></b-spinner>
          </b-button>
      </template>
      <div style="display: flex; justify-content: center" v-show="loading">
          <b-spinner class="text-center" v-show="loading" big></b-spinner>
      </div>
    </b-modal>
</template>
